<template>
  <div>
    <el-container style="width:100%;">
      <el-header>
        <el-radio-group v-model="group_id" style="margin-top 1%;">
          <el-radio-button label="new_arrivals">{{ generateCustomizeString('newArrivals') }}</el-radio-button>
          <el-radio-button label="recommended_product">{{ generateCustomizeString('recomendedProducts') }}</el-radio-button>
          <el-radio-button label="discount_product">{{ generateCustomizeString('limitedTimeDiscount') }}</el-radio-button>
          <el-radio-button label="about_us">{{ generateCustomizeString('aboutUs') }}</el-radio-button>
        </el-radio-group>
        <span>{{ generateCustomizeString('clickToEditRelatedBanner') }}</span>
      </el-header>
      <el-main>
        <banner-edit :groupId="group_id" ref="bannerEdit" />
        <!-- <banner-edit v-if="group_id === 'recommended_product'" :groupId="group_id" /> -->
        <!-- <banner-edit v-if="group_id === 'discount_product'" :groupId="group_id" /> -->
        <!-- <banner-edit v-if="group_id === 'about_us'" :groupId="group_id" /> -->
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import BannerEdit from '@/components/Shop/Theme/BannerEdit.vue'

export default {
  name: 'ThemeCustomization',
  components: {
    BannerEdit
  },
  activated() {
    console.log('activated')
    console.log(this.group_id)
    this.$refs.bannerEdit.fetchBanner(1, this.group_id)
  },
  data() {
    return {
      group_id: 'new_arrivals'
    }
  },
  watch: {
    group_id: function(newGroupId, oldGroupId) {
      this.$refs.bannerEdit.fetchBanner(1, newGroupId)
    }
  },
  methods: {
    generateCustomizeString
  }
}
</script>

<style lang="less" scoped>
  .el-header {
    padding-top: 2%;
    span {
      color: red;
      font-size: 12px;
      margin-left: 20px;
    }
  }
</style>
